import { BridgeComponent } from "@hotwired/hotwire-native-bridge"
import { post } from "@rails/request.js"

// Bridge component for CONEK-4571 P6 push notifications. On connect, asks the
// native shell to request the POST_NOTIFICATIONS permission (API 33+; a
// no-op grant on older Android) and the current FCM registration token, then
// POSTs the token to `/api/v1/mobile/device_tokens` so the server can target
// this device.
//
// Mounted on the mobile layout only when `mobile.rep.push` is on for the
// tenant, signalled via `<meta name="mobile-rep-push" content="true">`
// (mirrors the same meta-tag-gating convention used elsewhere on the mobile
// shell — see app/views/layouts/mobile.html.erb). Graceful degradation: if
// the meta tag is absent, or no bridge is present (plain mobile browser, not
// the Turbo Native shell), every method is a no-op.
export default class extends BridgeComponent {
  static component = "push-permission"

  connect() {
    if (!this.enabled()) return

    super.connect()
    this.send("request_permission", {}, (message) => {
      this.handleReply(message)
    })
  }

  enabled() {
    return (
      document.querySelector('meta[name="mobile-rep-push"]')?.content === "true"
    )
  }

  handleReply(message) {
    if (!message) return
    // The bridge callback receives the full message envelope {id, component, event, data: {...}}.
    // Extract the payload; fall back to the raw argument for direct callers (tests, etc.).
    const data =
      message.data !== null &&
      message.data !== undefined &&
      typeof message.data === "object"
        ? message.data
        : message
    if (!data) return

    if (!data.granted || !data.token) return

    post("/api/v1/mobile/device_tokens", {
      body: JSON.stringify({ token: data.token, platform: "android" }),
      contentType: "application/json",
      responseKind: "json",
    })
  }
}
